import React, { useState, useEffect, useMemo, useRef } from "react";
import { HotTable, HotColumn } from "@handsontable/react";
import { Modal, Button, Input, Table, Select, Radio, DatePicker } from "antd";
import {
  drawCheckboxInRowHeaders,
  addClassesToRows,
  alignHeaders,
} from "./handsontableHelpers";
import "handsontable/dist/handsontable.min.css";
import { API_BASE_URL } from "../../services/apiConfig";
import AuthService from "../../services/auth.service";
import {API_BASE_URL_ISSUER} from "../../services/apiConfig";
import moment from "moment";
import dayjs from "dayjs";
const { Option } = Select;
interface ExcelViewProps {
  data: any[];
  membercount: number;
  addition: number;
  SelectValue: string;
  memberlistcolumncount: number;
  selectedClubInfo: number;
  onRowSelect: (rowIndex: number, rowData: any[]) => void;
  onExcelrowClick: (excelrowdata: string) => void;
  onupdate: (updatevalue: boolean) => void;
}

const ExcelView: React.FC<ExcelViewProps> = ({
  addition,
  membercount,
  data,
  SelectValue,
  memberlistcolumncount,
  selectedClubInfo,
  onRowSelect,
  onExcelrowClick,
  onupdate,
}) => {
  const [token, settoken] = useState<string | null>(null);
  const [familyInfo, setFamilyInfo] = useState([
    { relationship: "", name: "", gender: "", birthdate: "", chartNumber: "" },
  ]);
  const [doubleClicked, setDoubleClicked] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [dataState, setDataState] = useState(data);
  const [copiedOnce, setCopiedOnce] = useState(false);
  const [copyfirst, setcopyfirst] = useState(false);
  const [copyheaders, setcopyheaders] = useState<any[]>([]);
  const [copybody, setcopybody] = useState<any[]>([]);
  const [clickedCell, setClickedCell] = useState<string>("");
  const [selectclubMemberSeq, setselectclubMemberSeq] = useState<number>(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [birthdate, setBirthdate] = useState<string | null>(null);
  const { TextArea } = Input;
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [waitmembermodalOpen, setwaitmemberModalOpen] = useState(false);
  const [selectwaitmemberModalname, setselectwaitmemberModalname] = useState("");
  const [selectwaitmemberphonenumber, setselectwaitmemberphonenumber] = useState("");
  const [memberwaitlocalname, setmemberwaitlocalname] = useState("");
  const [newwaitname, setnewwaitname] = useState("");
  const handleClick = (event: any, coords: any, TD: any) => {
    // const cellvalue = TD.innerText;
    // // console.log("클릭한 셀값 ", cellvalue);

    // const division = TD.innerText.substr(0, 2); // 왼쪽에서 두 번째까지의 글자 추출
    const cellvalue = TD.innerText;

    // Find the row index based on the clicked cell
    const rowIndex = data.findIndex((row) => row.includes(cellvalue));

    console.log("선택한 인덱스 " + coords.row);
    if (coords.row !== -1) {
      // Extract the entire row information
      const clickedRow = data[coords.row + 1];
      console.log("Clicked Row Information:", clickedRow);
      if (Array.isArray(clickedRow) && clickedRow.length >= 2) {
        const [name, phoneNumber] = clickedRow;
        console.log("클럽넘버  : " +selectedClubInfo)
        fetch(
          `${API_BASE_URL}/club/member/list/${selectedClubInfo}?page=0&size=20000&sort=clubMemberSeq,desc`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log(data.data.content);

            const matchingMember = data.data.content.find(
              (member: any) =>
                member.memberName === name &&
                member.mobileNumber === phoneNumber
            );
            console.log("선택 로우" + JSON.stringify(matchingMember, null, 2));
            console.log("선택 로우" + matchingMember.localName);
            setselectwaitmemberModalname(matchingMember.memberName)
            setmemberwaitlocalname(matchingMember.localName)
            setselectwaitmemberphonenumber(matchingMember.mobileNumber)

            // console.log("선택한 클럽맴버시퀀스" + JSON.stringify(matchingMember.clubMemberSeq))
            setselectclubMemberSeq(parseInt(matchingMember.clubMemberSeq, 10));
            if (matchingMember) {
              // Extract extraData from the matching member
              const extraData = JSON.parse(matchingMember.extraData);
              console.log("가족길이 " + extraData.가족);
              if (extraData.가족 !== undefined) {
                console.log("가족있음");
                console.log("Extra Data:", extraData.가족);
                console.log("Extra Datacount:", extraData.가족.length);

                const numberOfItems = extraData.가족.length;

                if (!isNaN(numberOfItems)) {
                  const initialFamilyInfo = extraData.가족.map(
                    (familyMember: any) => ({
                      relationship: familyMember.관계 || "",
                      name: familyMember.이름 || "",
                      gender: familyMember.성별 || "",
                      birthdate: familyMember.생년월일 || "",
                      chartNumber: familyMember.차트번호 || "",
                    })
                  );

                  // setselectwaitmemberModalname("히히")
                  
                  setFamilyInfo(initialFamilyInfo);



                }
              } else {
                console.log("가족없음");
                setFamilyInfo([]);
              }
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });

        // Open the modal

        if (coords.col === 5) {
          console.log("가족선택")
          setIsModalVisible(true);
          
        }                  
        if(coords.col ===4 || coords.col ===0){
          waitmembertoggleModal()
        }


      } else {
        console.log("Invalid clickedRow:", clickedRow);
      }
    }

    setClickedCell(cellvalue);
    setClickedCell(cellvalue);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll); //clean up
    };
  }, []);

  const handleScroll = () => {
    
    console.log("window.scrollY : ", window.scrollY)
  };

  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    // console.log("토큰 : "  + rawToken)
    settoken(rawToken);
  }, [token]);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      console.log("가로사이즈 : " + window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleRemoveItem = (index: number) => {
    setFamilyInfo((prevFamilyInfo) =>
      prevFamilyInfo.filter((_, i) => i !== index)
    );
  };
  const columnHeaders = useMemo(() => {
    if (data.length > 0) {
      // console.log("(ExcelView) 헤더 : " +  data[1])
      return data[1];
    }
    return [];
  }, [data]);
  const hotSettings = useMemo(() => {
    return {
      sortIndicator: false,
      autoColumnSize: true,
      contextMenu: false,
      // ... (other configurations)
    };
  }, [data]);
  // const columnWidths = useMemo(() => {

  //     return Array.from({ length: memberlistcolumncount+6 }, () => (150));

  // }, [SelectValue, width]);


  const handleDateChange = (
    selectedDate: dayjs.Dayjs | null,
    dateString: string,
    index: number
  ) => {
    if (selectedDate) {
      const formattedDate = selectedDate.format("YYYY-MM-DD");
      console.log("Selected date:", formattedDate);
      setBirthdate(formattedDate);
      console.log("Birthdate state updated:", formattedDate);

      // 변경된 날짜를 해당 인덱스의 info에 업데이트합니다.
      setFamilyInfo((prevFamilyInfo) => {
        const updatedFamilyInfo = [...prevFamilyInfo];
        updatedFamilyInfo[index] = {
          ...updatedFamilyInfo[index],
          birthdate: formattedDate,
        };
        return updatedFamilyInfo;
      });
    } else {
      console.log("No date selected");
    }
  };
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | { value: any }>, // input 엘리먼트 이외의 경우를 처리하기 위해 { value: any } 추가
    field: string,
    index: number
  ) => {
    const { value } = event.target || {}; // event.target이 존재하지 않을 경우를 대비해 기본값 설정

    // 이벤트 객체에서 value 속성에 안전하게 접근하여 값 가져오기
    setFamilyInfo((prevFamilyInfo) =>
      prevFamilyInfo.map((info, i) =>
        i === index ? { ...info, [field]: value } : info
      )
    );
  };
  const handleConfirm = () => {
    // 합쳐진 가족 정보 생성
    const combinedFamilyInfo = {
      가족: familyInfo.map((info) => ({
        관계: info.relationship,
        이름: info.name,
        성별: info.gender,
        생년월일: info.birthdate
          ? moment(info.birthdate).format("YYYY-MM-DD")
          : "", // 날짜 형식 변환
        차트번호: info.chartNumber,
      })),
    };
    if (!familyInfo.every(info => info.gender === '남' || info.gender === '여')) {
      alert('성별은 "남" 또는 "여"로 입력해주세요.');
      return; // 함수 종료
    }
    // 콘솔에 출력
    console.log(JSON.stringify(combinedFamilyInfo));

    const postData = {
      clubMemberSeq: selectclubMemberSeq,
      extraData: combinedFamilyInfo,
    };

    // console.log("보내는값 : " + JSON.stringify(postData));

    fetch(`${API_BASE_URL}/club/member/extradata/update`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log("(ExcelUpload) PUT 요청 성공:", data);
        // console.log("진료실 수정완료");
        setIsModalVisible(false);
        onupdate(true);
      });
  };
  const waitmembertoggleModal = () => {

    setwaitmemberModalOpen(!waitmembermodalOpen);
  };
  const handleGenderChange = (value: any, field: string, index: number) => {
    // console.log("선택값 : " + value);

    setFamilyInfo((prevFamilyInfo) =>
        prevFamilyInfo.map((info, i) =>
            i === index ? { ...info, [field]: value } : info
        )
    );
};
  
  const handlerelationshipChange = (value: any, field: string, index: number) => {
    // console.log("선택값 : " + value);

    setFamilyInfo((prevFamilyInfo) =>
        prevFamilyInfo.map((info, i) =>
            i === index ? { ...info, [field]: value } : info
        )
    );
};
  const waitmemberhandleConfirm = () => {
    // 대기 기존회원 정보 수정

        const patchData = {
          clubSeq: selectedClubInfo,
          mobileNumber: selectwaitmemberphonenumber,
          localName: memberwaitlocalname
        };

        console.log("수정내용" + JSON.stringify(patchData,null,2))

        fetch(`${API_BASE_URL_ISSUER}/clubmembers/localname`, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(patchData),
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
            })
            .catch(error => {
              console.error('There was an error with the PATCH request:', error);
            });

  
            waitmembertoggleModal();




  };
  const memberwaitlocalnamehandleInputChange = (e: any) => {

    setmemberwaitlocalname(e.target.value);
  };

  const handleAddItem = () => {
    setFamilyInfo((prevFamilyInfo) => [
      ...prevFamilyInfo,
      {
        relationship: "",
        name: "",
        gender: "",
        birthdate: "",
        chartNumber: "",
      },
    ]);
  };
  const waitnamehandleInputChange = (e: any) => {
    setnewwaitname(e.target.value);
  };

  const handleRowSelect = (rowIndex: number, rowData: any[]) => {
    const excelrowdata = JSON.stringify(rowData);

    if (excelrowdata) {
      onExcelrowClick(excelrowdata);
    }
  };
  // if(addition===0){
  //   window.alert("회원 추가하기버튼을 클릭해서 추가해주세요"); // 성공 메시지
  // }
  // console.log("(ExcelView) 추가회원 수 : " + addition);

  // scrollbarColor: "gray lightgray", // 스크롤바의 색상을 지정합니다.
  // backgroundColor:"black",

  // overflow: "hidden",
  useEffect(() => {
    const handleScroll = () => {
      if (scrollContainerRef.current) {
        const { scrollTop } = scrollContainerRef.current;
        console.log("스크롤 위치:", scrollTop);
      }
    };
  
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }
  
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (

    <div ref={scrollContainerRef} onScroll={handleScroll} style={{ width: "1200px", height: "800px", overflowY: "auto", scrollbarColor: "gray lightgray" }}>

      <Modal
        title="회원 정보 수정"
        style={{ fontSize: "18px", borderRadius: "20px" }}
        open={waitmembermodalOpen}

        // onCancel={() => setWaitIsModalVisible(false)}
        onCancel={waitmembertoggleModal}
        width={800}
        footer={[
          <div key="button-container" style={{ textAlign: "center" }}>
            <Button
              key="confirm"
              type="primary"
              onClick={waitmemberhandleConfirm}
              style={{
                width: "220px",
                height: "56px",
                borderRadius: "20px",
                color: "#fff",
                background: "#2D5478",
                borderColor: "#2D5478",
              }}
            >
              저장
            </Button>
          </div>
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <div style={{ display: "flex", marginBottom: "8px" }}>
            <div style={{ marginRight: "8px", width: "300px" }}>이름</div>
            <div style={{ marginRight: "8px", width: "300px" }}>차트번호</div>
          </div>

          <div style={{ display: "flex", marginBottom: "8px" }}>

            <Input
              placeholder="이름"
              value={selectwaitmemberModalname}
              onChange={waitnamehandleInputChange}
              readOnly
              style={{ marginRight: "8px", width: "300px" }}
            />
            <Input
              placeholder="차트번호"
              value={memberwaitlocalname}
              onChange={memberwaitlocalnamehandleInputChange}
              style={{ marginRight: "8px", width: "300px" }}
            />
          </div>
        </div>
      </Modal>

      <Modal
                        title="가족정보 수정"
                        style={{ fontSize: "18px", borderRadius: "20px" }}
                        open={isModalVisible}
                        onCancel={() => setIsModalVisible(false)}
                        width={800}
                        footer={[
                            <div key="button-container" style={{ textAlign: "center" }}>
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={handleConfirm}
                                    style={{
                                        width: "220px",
                                        height: "56px",
                                        borderRadius: "20px",
                                        color: "#fff",
                                        background: "#2D5478",
                                        borderColor: "#2D5478",
                                    }}
                                >
                                    저장
                                </Button>
                            </div>,
                        ]}
                    >
                        <div style={{ marginBottom: "16px" }}>
                            {/* Headers */}
                            <div style={{ display: "flex", marginBottom: "8px" }}>
                                <div style={{ marginRight: "8px", width: "150px" }}>관계</div>
                                <div style={{ marginRight: "8px", width: "150px" }}>이름</div>
                                <div style={{ marginRight: "8px", width: "150px" }}>성별</div>
                                <div style={{ marginRight: "8px", width: "150px" }}>생년월일</div>
                                <div style={{ marginRight: "8px", width: "150px" }}>차트번호</div>
                            </div>
                            {/* Input fields */}
                            {familyInfo.map((info, index) => (
                                <div key={index} style={{ display: "flex", marginBottom: "8px" }}>
                                    <Select
                                        value={info.relationship}
                                        placeholder="부모"
                                        defaultValue={null}
                                        onChange={(value: any) =>
                                            handlerelationshipChange(value, "relationship", index)
                                        }
                                        style={{ width: "100%", marginRight: "8px" }}
                                    >
                                        <Option value="부모">부모</Option>
                                        <Option value="자녀">자녀</Option>
                                        <Option value="기타">기타</Option>
                                    </Select>
                                    <Input
                                        placeholder="이름"
                                        value={info.name}
                                        onChange={(e) => handleInputChange(e, "name", index)}
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Select
                                        value={info.gender}
                                        onChange={(value: any) =>
                                            handleGenderChange(value, "gender", index)
                                        }
                                        style={{ width: "100%", marginRight: "8px" }}
                                    >
                                        <Option value="남">남</Option>
                                        <Option value="여">여</Option>
                                        <Option value="기타">기타</Option>
                                    </Select>
                                    <DatePicker
                                      clearIcon
                                        placeholder="생년월일 선택"
                                        value={
                                            info.birthdate
                                                ? dayjs(info.birthdate)
                                                : birthdate
                                                    ? dayjs(birthdate)
                                                    : null
                                        }
                                        onChange={(date, dateString) =>
                                            handleDateChange(date, dateString, index)
                                        }
                                        style={{ marginRight: "8px", width: "100%" }}
                                        defaultPickerValue={dayjs('1980-01-01')}

                                    />
                                    {/* </div> */}
                                    <Input
                                        placeholder="차트번호"
                                        value={info.chartNumber}
                                        onChange={(e) => handleInputChange(e, "chartNumber", index)}
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Button
                                        onClick={() => handleRemoveItem(index)}
                                        style={{ width: "32px" }}
                                    >
                                        -
                                    </Button>
                                </div>
                            ))}
                            <Button
                                type="primary"
                                style={{ width: "100%", marginBottom: "8px" }}
                                onClick={handleAddItem}
                            >
                                + 추가
                            </Button>
                        </div>
                    </Modal>

      <HotTable
        data={copiedOnce ? data.slice(2) : data.slice(1)}
        width="100%"
        height="800px"

        settings={hotSettings}
        colHeaders={
          membercount >= 2 ? data[0] : copiedOnce ? copyheaders : data[0]
        }
        readOnly={true}
        // colWidths={columnWidths}
        hiddenColumns={{
          indicators: true,
        }}
        afterChange={(changes, source) => {
          if (source === "CopyPaste.paste" && changes) {
            if (membercount >= 2) {
            } else {
              if (copyfirst == false) {
                setcopyheaders(data[1]);
                setcopybody(data.slice(1));
                setCopiedOnce(true);
                setcopyfirst(true);
              }
            }
          }
        }}
        contextMenu={false}
        multiColumnSorting={true}
        rowHeaders={true}
        afterGetColHeader={alignHeaders}
        beforeRenderer={(TD, row, column, prop, value, cellProperties) => {
          if (row >= addition && addition >= 1) {
            TD.style.color = "blue";
          }
        }}
        manualRowMove={true}
        licenseKey="non-commercial-and-evaluation"
        afterOnCellMouseDown={handleClick}
        afterSelection={(
          r,
          c,
          r2,
          c2,
          preventScrolling,
          selectionLayerLevel
        ) => {
          const selectedRowData = dataState[r + 1];
          onRowSelect(r, selectedRowData);
          handleRowSelect(r, selectedRowData);
        }}
      >
        {Array.from({ length: memberlistcolumncount + 10 }, (_, index) => (
          <HotColumn key={index} data={index} />
        ))}
      </HotTable>
    </div>
  );
};

export default ExcelView;
